import Vue from 'vue';

/** Event bus for sending dashboard events. */
const DashboardEventBus = new Vue();

export default DashboardEventBus;
